export const PREDICTIONS_PAGE_LIMIT = 12;

export const LANGUAGE_OPTIONS = [
  { code: "en", display: "EN" },
  // { code: "hi", display: "हिंदी" }
];

export const PREDICTION_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'active' },
  { value: 'APPLIED', label: 'applied' },
  { value: 'EXPIRED', label: 'expired' },
  { value: 'FAILED', label: 'failed' },
  { value: 'NOT_APPLICABLE', label: 'Not Applicable' }
];

export const PREDICTION_STATUS_CLASSES: Record<string, string> = {
  ACTIVE: 'bg-[#CEDFD5] hover:bg-[#CEDFD5] text-[#0C612C] border border-[#0C612C]',
  APPLIED: 'bg-[#F9FEFD] hover:bg-[#F9FEFD] text-[#5A6463] border border-[#5A6463]',
  EXPIRED: 'bg-[#FFDEDE] hover:bg-[#FFDEDE] text-[#FF2727] border border-[#FF2727]',
  FAILED: 'bg-[#FFDCE9] hover:bg-[#FFDCE9] text-[#FF005E] border border-[#FF005E]',
  NOT_APPLICABLE: 'bg-[#E7CBFF] hover:bg-[#E7CBFF] text-[#8F22EF] border border-[#8F22EF]',
}; 